import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';

import { ApiService } from '@core/providers/http';

@Injectable({
  providedIn: 'root'
})
export class RondaService {

  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) {}

 
  list(params?: any): Observable<any> {
    return this.apiService.get(
      `/api/Ronda`,
      params
        ? new HttpParams({
            fromObject: params
          })
        : this.params
    ).pipe(
      map(response => response)
    );
  }

  show(id: string | number): Observable<any> {
    return this.apiService.get(
      `/api/Ronda/${id}`
    ).pipe(
      map(response => response)
    );
  }

  /**
   * Obtém a ronda aberta de uma escala para um efetivo.
   *
   * GET /api/Ronda/escala/{escalaId}/{efetivoId}/aberta
   */
  aberta(
    escalaId: string | number,
    efetivoId: string | number
  ): Observable<any> {
    return this.apiService.get(
      `/api/Ronda/escala/${escalaId}/${efetivoId}/aberta`
    ).pipe(
      map(response => response)
    );
  }

  /**
   * Obtém as rondas de uma escala.
   *
   * GET /api/Ronda/escala/{escalaId}
   */
  porEscala(
    escalaId: string | number
  ): Observable<any> {
    return this.apiService.get(
      `/api/Ronda/escala/${escalaId}`
    ).pipe(
      map(response => response)
    );
  }

  /**
   * Obtém as rondas fechadas de uma escala.
   *
   * GET /api/Ronda/escala/{escalaId}/fechadas
   */
  fechadasPorEscala(
    escalaId: string | number
  ): Observable<any> {
    return this.apiService.get(
      `/api/Ronda/escala/${escalaId}/fechadas`
    ).pipe(
      map(response => response)
    );
  }

  /**
   * Cria uma nova ronda.
   *
   * POST /api/Ronda
   */
  store(ronda: any): Observable<any> {
    return this.apiService.post(
      `/api/Ronda`,
      ronda
    );
  }
}